export class Profil {
    user_ref: any;
    email_address: any;
    current_password: any;
    password: any;
    confirm_password: any;
    name: any;
    surname: any;
    phone: any;

    private errorMessage: string;

    constructor() {
        this.errorMessage = "";
    }

    canSend(): boolean {

        if (this.current_password === undefined || this.current_password === null || this.current_password.trim() === "") {
            this.errorMessage = "Veuillez renseigner votre mot de passe actuel";
            return false;
        }

        if (this.password === undefined || this.password === null || this.password.trim() === "") {
            this.errorMessage = "Veuillez renseigner votre nouveau mot de passe";
            return false;
        }

        if (this.password.trim().length <= 3) {
            this.errorMessage = "Votre mot de passe est trop court.";
            return false;
        }

        if (this.confirm_password === undefined || this.confirm_password !== this.password) {
            this.errorMessage = "Les mots de passe ne correspondent pas";
            return false;
        }

        return true;
    }

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
